"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildLang = exports.setI18nLang = exports.getI18nLang = exports.createI18nRaw = exports.createI18n = exports.createKeyset = void 0;
var i18n_1 = require("./i18n");
Object.defineProperty(exports, "createKeyset", { enumerable: true, get: function () { return i18n_1.createKeyset; } });
Object.defineProperty(exports, "createI18n", { enumerable: true, get: function () { return i18n_1.createI18n; } });
Object.defineProperty(exports, "createI18nRaw", { enumerable: true, get: function () { return i18n_1.createI18nRaw; } });
Object.defineProperty(exports, "getI18nLang", { enumerable: true, get: function () { return i18n_1.getI18nLang; } });
Object.defineProperty(exports, "setI18nLang", { enumerable: true, get: function () { return i18n_1.setI18nLang; } });
Object.defineProperty(exports, "BuildLang", { enumerable: true, get: function () { return i18n_1.BuildLang; } });
